export const MAX_COUPON_CODE_DISPLAY_LENGTH = 14;
const TRUNCATION_MARKER = '...';

export const isCouponCodeTruncated = (code: string | null): boolean =>
  !!code && code.length > MAX_COUPON_CODE_DISPLAY_LENGTH;

export const formatCouponCodeForDetails = (code: string | null): string => {
  if (!code) {
    return '';
  }

  if (!isCouponCodeTruncated(code)) {
    return code;
  }

  return `${code.slice(
    0,
    MAX_COUPON_CODE_DISPLAY_LENGTH - TRUNCATION_MARKER.length,
  )}${TRUNCATION_MARKER}`;
};
